import { useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import AdminLayout from "../../../AdminLayout";
import DeleteConfirmation from "../../../Components/DeleteConfirmation";
import EmptyContent from "../../../Components/Empty-content/EmptyContent";
import ItemsLoader from "../../../Components/Loader/basic loader/ItemsLoader";
import PaginationComponent from "../../../Components/Pagination";
import { useStudentPaymentTransactions } from "../../../Store/CashControlStore/StudentPaymentTransactions";
import { useLoaderStore } from "../../../Store/Loader/LoaderStore";
import Heading from "./components/Heading";
import ListItem from "./components/ListItem";
import TitleBar from "./components/TitleBar";

export default function StudentsPaymentTransactions() {
  const {
    students,
    onReload,
    isLoading,
    loadItems,
    setLoading,
    pagination,
    updateParams,
    queryParams,
    deletingId,
    deleteTransaction,
    isShowDeleteLoader,
  } = useStudentPaymentTransactions();
  const { setLoader } = useLoaderStore();

  const pageLoad = useCallback(async () => {
    setLoading(false);
    const queryString = new URLSearchParams({
      ...queryParams,
    }).toString();
    setLoader(true);
    await onReload(queryString);
    setLoader(false);
  }, []);

  useEffect(() => {
    pageLoad();
    document.body.addEventListener("click", handleClickClosePanelFromOutside);
    return () => {
      document.body.removeEventListener(
        "click",
        handleClickClosePanelFromOutside
      );
    };
  }, []);

  const handleClickClosePanelFromOutside = (e) => {
    if (!e.target.className.includes("build-table__item--7")) {
      useStudentPaymentTransactions.setState({
        openContextMenu: null,
      });
    }
  };

  const paginateTo = useCallback(
    async (page) => {
      const queryString = new URLSearchParams({
        ...queryParams,
        page: page,
      }).toString();
      setLoading(true);
      updateParams({ page: page });
      await loadItems(queryString);
      setLoading(false);
    },
    [queryParams]
  );
  const deleteAction = async (e) => {
    e.preventDefault();
    const findTransaction = students?.find((item) => item.id === deletingId);
    await deleteTransaction(deletingId, findTransaction?.payment_mode);
  };

  const cancelConfirmation = (e) => {
    e.preventDefault();
    useStudentPaymentTransactions.setState({
      deletingId: null,
      isShowDeleteLoader: false,
    });
  };

  const { t } = useTranslation();

  return (
    <AdminLayout>
      <TitleBar title={t("To'lovlar tarixi")} />
      <div className="container">
        <Heading />
        {isLoading ? (
          <ItemsLoader size={70} />
        ) : students?.length > 0 ? (
          students.map((student, index) => {
            return <ListItem key={index} student={student} index={index} />;
          })
        ) : (
          <EmptyContent />
        )}
        <DeleteConfirmation
          showModal={{
            deletingId: deletingId,
            isShowDeleteLoader: isShowDeleteLoader,
          }}
          deleteCallback={deleteAction}
          cancelCallback={cancelConfirmation}
        />
        <PaginationComponent
          context={{ pagination: pagination, queryParams: queryParams }}
          callback={paginateTo}
        />
      </div>
    </AdminLayout>
  );
}
